import { writable } from "svelte/store";

export const seo = writable({
    title: "",
    description: "",
    keywords: "",
    img: ""
})